import type React from 'react'
import { Button } from '@components/ui/button'
import { cn } from '@/utils'

interface PointTypeButtonProps {
  pointType: string
  label: string
  Icon: React.ElementType
  selectedPointType: string | null
  setSelectedPointType: (type: string | null) => void
}

/** Toggles the pen tool's point type for newly placed anchors; clicking the active type clears it. */
export function PointTypeButton({
  pointType,
  label,
  Icon,
  selectedPointType,
  setSelectedPointType,
}: PointTypeButtonProps) {
  const isActive = selectedPointType === pointType

  return (
    <Button
      variant="ghost"
      size="icon"
      aria-pressed={isActive}
      aria-label={label}
      onClick={() => setSelectedPointType(isActive ? null : pointType)}
      className={cn(
        !isActive && 'text-muted-foreground',
        isActive && 'bg-accent text-accent-foreground'
      )}
    >
      <Icon className="w-4 h-4" />
    </Button>
  )
}
